import React, { useState, useEffect } from 'react';
import '../css/animate.css';
import '../css/barvy.css';
import '../css/style.css';
import { motion } from 'framer-motion';
import { builder } from '../utils/builderWithLocale';
import EditableField from '../editry/EditableField';

function App({ scrollTo }) {
  const [content, setContent] = useState();
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);

  useEffect(() => {
    // Delay video loading to change priority
    const timer = setTimeout(() => {
      setShouldLoadVideo(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Check if preloaded header data is available
    if (window.preloadedHomeData && window.preloadedHomeData.headerData) {
      //console.log("Using preloaded header data");
      setContent(window.preloadedHomeData.headerData);
    } else {
      // Fallback to fetching header data
      builder
      .get("header")
      .then((data) => {
        setContent(data);
      })
      .catch((error) => console.error("Error fetching header content:", error));
    }
  }, []);



  if (!content?.data) {
    return <div></div>;
  }

  return (
    <motion.div
      key="header"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div id="wrapper">
        <header 
          id="banner" 
          className="scrollto clearfix" 
          style={{
            position: 'relative',
            overflow: 'hidden',
            ...(!content.data.video || content.data.video === '')
          }}
        >
          {shouldLoadVideo && content.data.video && content.data.video !== '' && (
            <video
              autoPlay
              muted
              loop
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                zIndex: 1
              }}
              onLoadStart={() => console.log('Video loading started')}
              onCanPlay={() => console.log('Video can play')}
              onError={(e) => console.error('Video error:', e)}
            >
              <source src={content.data.video} type="video/mp4" />
            </video>
          )}
          <div id="banner-content" className="row clearfix" style={{ position: 'relative', zIndex: 2 }}>
            <div className="col-38">
              <hr className="section-heading-header-hr" />
              <div className="section-heading-header">
                <h1 className="barlow-extrabold shadow" id="hlavni-nadpis">
                  <EditableField model="header" item={content} field="nazev">
                    {content.data.nazev || 'loading...'}
                  </EditableField>
                </h1>
                <h2 id="hlavni-popis" className="barlow-medium shadow">
                  <EditableField model="header" item={content} field="popis">
                    {content.data.popis || 'loading...'}
                  </EditableField>
                </h2>
              </div>
              <a
                href="#kola"
                className="pointer weird-button barlow-semibold animated scrollto clearfix"
              >
                <span>
                  <EditableField model="header" item={content} field="tlacitko">
                    {content.data.tlacitko || 'loading...'}
                  </EditableField>
                </span>
              </a>
            </div>
          </div>
        </header>
      </div>
    </motion.div>
  );
}

export default App;
